import MainLayout from "../layouts/MainLayout";

import OffersHero from "../components/OffersHero";
import FeaturedOffers from "../components/FeaturedOffers";
// import OfferBenefits from "../components/OfferBenefits";
// import OfferCTA from "../components/OfferCTA";

import "../components/SpecialOffers.css";

export default function SpecialOffers() {
  return (
    <MainLayout>

      <OffersHero />
 
      <FeaturedOffers />
{/*
      <OfferBenefits />

      <OfferCTA /> */}

    </MainLayout>
  );
}
